<template>
  <Permissioned section="workers" vertical>
    <BaseDetails permission="view.cv">
      <template v-slot:header>
        <h3>CV</h3>
        <v-btn class="fullscreen-button" text @click="handleViewCV">
          <span class="button-content">Full-Screen</span>
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
      </template>
      <template v-slot:body>
        <embed :src="cvUrlWithToken" :style="styles" type="application/pdf" />
        <PDFViewFull :data="fileDialog" />
      </template>
    </BaseDetails>
  </Permissioned>
</template>

<script>
import BaseDetails from "@/components/common/BaseDetails/BaseDetails";
import Permissioned from "@/components/common/Permissioned";
import PDFViewFull from "@/components/common/PDFViewFull";
import { getToken } from "@/services/utils";

export default {
  name: "CVPreview",
  components: { Permissioned, BaseDetails, PDFViewFull },
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  props: {
    type: String,
    url: String
  },
  computed: {
    cvUrlWithToken() {
      const token = getToken();
      return `${this.url}?token=${token}`;
    },
    styles() {
      return { width: "100%", height: "450px", marginBottom: "15px" };
    }
  },
  methods: {
    handleViewCV() {
      this.fileDialog.src = this.cvUrlWithToken;
      this.fileDialog.title = "CV";
      this.fileDialog.dialog = true;
    }
  }
};
</script>

<style lang="scss">
.fullscreen-button.v-btn {
  color: $primary-darker;

  .button-content {
    font-weight: bold;
    text-transform: none;
  }

  .v-icon {
    margin-left: 0.25rem;
  }
}
</style>
